import { UUID } from 'game/model/PlayerModel';

// helper functions
const gtagAvaiable = () => {
  return window?.parent?.gtag || false;
};

const parseScores = (data) => {
  let returnData = {};

  for (let key in data) {
    const value = data[key];
    returnData[key.replace('update_', '')] = value;
  }

  return returnData;
};

// Geographical location -

export const trackCountry = ({ country }) => {
  if (!gtagAvaiable()) {
    console.log('gtag not avaiable');
    return;
  }

  console.log('event', 'geo_location', {
    user_id: UUID,
    country,
  });

  window.parent.gtag('event', 'geo_location', {
    user_id: UUID,
    country,
  });
};

// Game start -

export const trackGameStart = ({ play_count }) => {
  if (!gtagAvaiable()) {
    console.log('gtag not avaiable');
    return;
  }

  console.log('event', 'level_start', {
    user_id: UUID,
    play_count,
  });

  window.parent.gtag('event', 'level_start', {
    user_id: UUID,
    play_count,
  });
};

// track scenario -
export const trackCurrentScenario = ({
  scenario_id,
  documents_read,
  players_choice,
  current_time,
  scenario_title,
}) => {
  const docs = documents_read.length > 0 ? documents_read.join(', ') : 'none';

  if (!gtagAvaiable()) {
    console.log('gtag not avaiable');
    return;
  }

  console.log('event', 'scenario_played', {
    user_id: UUID,
    scenario_id,
    scenario_title,
    documents_read: docs,
    players_choice,
    current_time,
  });

  window.parent.gtag('event', 'scenario_played', {
    user_id: UUID,
    scenario_id,
    scenario_title,
    documents_read: docs,
    players_choice,
    current_time,
  });
};

// Game end -

export const trackGameEnd = ({ play_count, status, start }) => {
  if (!gtagAvaiable()) {
    console.log('gtag not avaiable');
    return;
  }

  const difference = Date.now() - start;
  const session = difference / (1000 * 60);

  console.log('event', 'level_end', {
    user_id: UUID,
    play_count,
    status,
    session_play_time: session,
  });

  window.parent.gtag('event', 'level_end', {
    user_id: UUID,
    play_count,
    status,
    session_play_time: session,
  });
};

// Game end scores -
export const trackGameEndScore = ({ play_count, scores, result }) => {
  if (!gtagAvaiable()) {
    console.log('gtag not avaiable');
    return;
  }

  console.log('event', 'post_score', {
    user_id: UUID,
    play_count,
    ...parseScores(scores),
    result,
  });

  window.parent.gtag('event', 'post_score', {
    user_id: UUID,
    play_count,
    ...parseScores(scores),
    result,
  });
};
